export default __webpack_public_path__ + "static/media/empty-betslip.cab80d51.png";